const Helpers = require('../../../../_plugins/lib/helpers')
const tracker = require('../../../../_plugins/lib/tracker')

const ContentHelper = {
  changeTab (e) {
    let anchor = e.target
    let hash = anchor.getAttribute('href')
    // Sometimes there are icons inside the anchor that get targetted on click, so when this happens we target the parent
    if (hash === null) anchor = anchor.parentNode
    hash = anchor.getAttribute('href')
    let parentElement = anchor.parentNode
    // Solves safari issue with persisted tab when it doesnt have any content (its a link)
    if (hash === '') return true
    // Necessary loop to make sure that we are selecting the correct tabs, sometimes we have tabs in tabs and they can get confused.
    const parentContainer = Helpers.getParentNode(anchor, 3)
    for (let child = 0; child < parentContainer.children.length; child++) {
      for (let node = 0; node < parentContainer.children[child].children.length; node++) {
        parentContainer.children[child].children[node].classList.remove('active')
      }
    }
    if ( Helpers.$('.tab-content .tab-pane.active', document) ) Helpers.$('.tab-content .tab-pane.active', document).classList.remove('active')
    Helpers.$(hash, document).classList.add('active')
    parentElement.classList.add('active')
    e.preventDefault()
    tracker.track('TabChange', hash.replace('#', ''))
    return false
  },

  openInNewWindow (e) {
    if (typeof window === 'undefined') return false
    window.open(e.target.getAttribute('data-newwindow'), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
    return false
  },

  // Activate a tab if it is set in the URL
  activateLocationHash (hash) {
    if (!window.location.hash && !hash) return
    if (!hash) hash = window.location.hash
    try {
      Helpers.$('#ContentArea a[href="' + hash + '"]').click()
    } catch (e) {}
  },

  hashScroll (item) {
    ContentHelper.activateLocationHash(item.srcElement.hash)
    window.scrollTo(0, item.offsetTop)
  },

  hashLinks () {
    const hashLinks = Helpers.$$('#ContentArea a[href^="#"]', document)
    for (let i = 0; i < hashLinks.length; i++) {
      hashLinks[i].onclick = this.hashScroll
    }
  },

  tabbableLinks () {
    const navTabs = Helpers.$$('#ContentArea .tabbable > .nav-tabs a', document)
    for (let i = 0; i < navTabs.length; i++) {
      navTabs[i].onclick = this.changeTab
    }
  },

  windowLinks () {
    const newWindowLinks = Helpers.$$('#ContentArea a[data-newwindow]', document)
    for (let i = 0; i < newWindowLinks.length; i++) {
      newWindowLinks[i].onclick = this.openInNewWindow
    }
  },

  attachEvents () {
    setTimeout(() => {
      this.hashLinks()
      this.tabbableLinks()
      this.windowLinks()
      this.activateLocationHash()
    }, 500)
  },

  regexScriptSrc: /<script(.*)src=["']?([^"' ]*)["']?><\/script>/gmi,
  regexScriptContent: /<script([^>]*)>((?!<\/script>)((.|[\r\n])*))<\/script>/gmi,

  appendJsSrc (html) {
    const jsSrcs = html.match(this.regexScriptSrc)
    if (jsSrcs && typeof window !== 'undefined') {
      jsSrcs.map((content, key) => {
        if (document.querySelector('#src_' + key)) return
        const scriptTag = document.createElement('script')
        scriptTag.id = 'src_' + key
        scriptTag.src = content.replace(/<script(?:.*)src=["']?/i, '').replace(/["']?><\/script>/i, '')
        document.querySelector('body').appendChild(scriptTag)
      })
    }
  },

  appendJsContent (html) {
    const jsContent = html.match(this.regexScriptContent)
    if (jsContent && typeof window !== 'undefined') {
      jsContent.map((content, key) => {
        if (document.querySelector('#content_' + key)) return
        const scriptTag = document.createElement('script')
        scriptTag.id = 'content_' + key
        scriptTag.innerHTML = `
(function() {
  var runCode = function () {
    ${content.replace(/(<script[^>]*>)/gi, '').replace(/(<\/script>)/gi, '')}
  }
  var i = setInterval(function () {
    if (!window.$) return
    clearInterval(i)
    runCode()
  }, 10)
}())`
        document.querySelector('body').appendChild(scriptTag)
      })
    }
  }
}

module.exports = ContentHelper



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contentHelper.js